import {t} from '../common/getTranslations';
import {showSimpleDialog} from '../dialog/simpleDialogHandler';

export function showRankingHelpDialog({isMobile}: {isMobile?: boolean}) {
  showSimpleDialog({
    title: '',
    description: t('landing_ranking_base'),
    isMobile: Boolean(isMobile),
    okButton: {
      text: t('common_confirm_button'),
      type: 'label',
      closeAfterClick: true,
    },
  });
}
